var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{fill-rule:evenodd;}.b{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7,8l.165-.047A2.641,2.641,0,0,0,8.994,5.619L9,5.438V2h1V5.5A3.5,3.5,0,0,1,7,8.964V22H6V8.965A3.5,3.5,0,0,1,3,5.5V2H4V5.438A2.64,2.64,0,0,0,5.835,7.953L6,8V2H7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.5,2C18.881,2,21,4.015,21,6.5c0,2.273-1.255,4.153-3,4.457V22H17V10.957c-1.745-.3-3-2.184-3-4.457C14,4.015,16.119,2,17.5,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.54c4592eb3efb0f8a6f89eec4608bcd3.svg";
export { ForwardRef as ReactComponent };